import { createContext, useContext, useState } from 'react';

const newEmailContext = createContext({} as any);

export function NewEmailProvider({ children }: any) {
  const [newEmail, setNewEmail] = useState('');

  return (
    <newEmailContext.Provider value={{ newEmail, setNewEmail }}>
      {children}
    </newEmailContext.Provider>
  );
}

export function useNewEmail() {
  return useContext(newEmailContext);
}